/**
 * Where we put expose the configuration files
 * It will extracted from environment variables
 */

const {
  NODE_ENV,
  VUE_APP_FBASE_KEY,
  VUE_APP_FBASE_DOMAIN,
  VUE_APP_FBASE_DATABASE,
  VUE_APP_FBASE_PROJECT_ID,
  VUE_APP_FBASE_STORAGE_BUCKET,
  VUE_APP_FBASE_SENDER_ID,
  VUE_APP_FBASE_COULD_FUNCTIONS,
  VUE_APP_BASE_API,
  VUE_APP_BASE_MIXPANEL,
  VUE_APP_SENDBIRD_APP_ID,
  VUE_APP_TABIKO_BOT_CONCIERGE_ID,
  VUE_APP_API_USERNAME,
  VUE_APP_API_PASSWORD
} = process.env;

export default {
  ENV: NODE_ENV,
  FirebaseKey: VUE_APP_FBASE_KEY,
  FirebaseDomain: VUE_APP_FBASE_DOMAIN,
  FirebaseDatabase: VUE_APP_FBASE_DATABASE,
  FirebaseProjectId: VUE_APP_FBASE_PROJECT_ID,
  FirebaseStorageBucket: VUE_APP_FBASE_STORAGE_BUCKET,
  FirebaseSenderId: VUE_APP_FBASE_SENDER_ID,
  firebaseFunctionsBaseUrl: VUE_APP_FBASE_COULD_FUNCTIONS,
  mixpanelBaseUrl: VUE_APP_BASE_MIXPANEL,
  BaseAPI: VUE_APP_BASE_API,
  APIUsername: VUE_APP_API_USERNAME,
  APIPassword: VUE_APP_API_PASSWORD,
  SendbirdAppId: VUE_APP_SENDBIRD_APP_ID,
  TabikoBotConciergeId: VUE_APP_TABIKO_BOT_CONCIERGE_ID,

  // Version coming automatically from package.json, refer to vue.config.js
  // eslint-disable-next-line no-undef
  Version: VERSION
};
